<template>
  <div class="controller-partner">
    <a-card
      :bordered="false"
      class="header-solid h-full"
      :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
    >
      <a-form-model :model="form" :rules="rules" ref="form">
        <a-form-model-item class="mb-5" label="Tên" prop="name">
          <a-input v-model="form.name" placeholder="Tên" />
        </a-form-model-item>
        <a-form-model-item class="mb-5" label="Mô tả" prop="description">
          <a-textarea
            :rows="4"
            v-model="form.description"
            placeholder="Mô tả"
          />
        </a-form-model-item>
        <a-form-model-item class="mb-5" label="Link" prop="link">
          <a-input v-model="form.link" placeholder="Link partner" />
        </a-form-model-item>
        <a-form-model-item class="mb-30" label="Ảnh" :colon="false">
          <input
            type="file"
            accept="image/png, image/svg, image/jpeg, image/gif, image/jpg"
            @change="onAvatarChange"
          />
        </a-form-model-item>
        <img
          v-show="avatarUrl"
          id="preview-avatar"
          :src="avatarUrl"
          class="preview-avatar"
        />
        <a-form-model-item>
          <a-row type="flex" justify="end">
            <a-button
              type="primary"
              :loading="callingAPI"
              @click="handleSubmit"
            >
              {{ $route.params.id ? "Cập nhật" : "Thêm mới" }}
            </a-button>
          </a-row>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import {
  createPartner,
  updatePartner,
  fetchPartnerById,
} from "@/services/landing-page/home/partner";
import { replaceUrlResource } from '@/utils/common'
export default {
  name: "ControllerPartner",
  data() {
    return {
      callingAPI: false,

      form: {
        name: "",
        description: "",
        link: "",
        image: null,
        status: 1,
      },
      rules: {
        name: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
        description: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
        link: [
          {
            required: true,
            message: "Giá trị không được để trống.",
            trigger: ["blur", "change"],
          },
        ],
      },

      avatarUrl: "",
    };
  },
  async beforeMount() {
    if (this.$route.params.id) {
      await this.loadData();
    }
  },
  methods: {
    async loadData() {
      try {
        const response = await fetchPartnerById(this.$route.params.id);
        this.form.name = response.data.name;
        this.form.description = response.data.description;
        this.form.link = response.data.link;
        this.form.status = response.data.status;

        this.avatarUrl = replaceUrlResource(response.data.image);
      } catch (error) {}
    },
    onAvatarChange(e) {
      if (e.target.files.length) {
        const file = e.target.files[0];
        this.form.image = file;
        this.avatarUrl = URL.createObjectURL(file);
      }
    },
    handleSubmit(e) {
      e.preventDefault();
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            this.callingAPI = true;
            if (!this.avatarUrl) {
              this.$message.error("Vui lòng upload ảnh đại diện!");
              this.callingAPI = false;
              return;
            }

            const formData = new FormData();
            formData.append("name", this.form.name);
            formData.append("description", this.form.description);
            formData.append("link", this.form.link);
            formData.append("status", this.form.status);

            if (this.form.image) {
              formData.append("image", this.form.image);
            }

            if (this.$route.params.id) {
              formData.append("_method", "PUT");
            }

            let response = null;
            if (this.$route.params.id) {
              response = await updatePartner(this.$route.params.id, formData);
            } else {
              response = await createPartner(formData);
            }
            console.log("response", response);
            if (response.status == 1) {
              const message = this.$route.params.id
                ? "Cập nhật thành công."
                : "Thêm mới thành công.";
              this.$notification.success({
                message: "Thành công",
                description: message,
              });
              this.$router.push({ name: "HomePartner" });
            } else {
              this.$notification.error({
                message: "Thất bại",
                description: response.errors[0],
              });
            }
          } catch (error) {
            this.callingAPI = false;
            console.log(error);
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#preview-avatar {
  max-width: 100%;
  object-fit: contain;
  display: block;
}
</style>